module.exports = __webpack_public_path__ + "img/lv.c01ba072.png";